module.exports = __webpack_public_path__ + "img/personal10.5b03a49f.png";